import React, { useState, useEffect } from "react";
import HeroMain from "./HeroMain";
import HeroEdit from "./HeroEdit";
import tasksjson from "./data/task-data.json";

export default function Hero({ isEdit, setEdit }) {
  // Initialize tasks with localStorage data if available, else use tasksjson
  const [tasks, setTasks] = useState(() => {
    const storedTasks = localStorage.getItem("tasksjson");
    return storedTasks ? JSON.parse(storedTasks) : [];
  });

  useEffect(() => {
    const storedTasks = localStorage.getItem("tasksjson");
    if (storedTasks) {
      setTasks(JSON.parse(storedTasks));
    }
  }, []);

  return isEdit ? (
    <HeroEdit
      setTasks={setTasks}
      tasks={tasks}
      taskGroups={tasks}
      isEdit={isEdit}
      setEdit={setEdit}
    />
  ) : (
    <HeroMain taskGroups={tasks} isEdit={isEdit} setEdit={setEdit} />
  );
}
